import Api from '@/api'

const App = {
  namespaced: true,

  state: {
    drawer: false,

    activeCompany: null,
    activeCompanyId: null,
    activeCompanyTk: null,
  },
  getters: {
    getDrawer: state => state.drawer
  },
  mutations: {
    setDrawer(state, payload) {
      state.drawer = payload;
    },
    setCompany(state, company_id){
      const local = localStorage.getItem('company_id')
      if (company_id){
        Api.Company.show(company_id).then((r)=>{
          state.activeCompany = r.data
        })
        state.activeCompanyId = company_id
        localStorage.setItem('company_id', state.activeCompanyId)
        //localStorage.setItem('company_tk', state.activeCompany.company_token)
      } else if(!company_id){
        state.activeCompany = null
        state.activeCompanyId = null
      } else {
        state.activeCompanyId = local
      }
    },
    setCompanyTk(state, company_tk){
      const local = localStorage.getItem('company_tk')
      if (company_tk){
        state.activeCompanyTk = company_tk
        localStorage.setItem('company_tk', state.activeCompanyTk)
      } else {
        state.activeCompanyTk = local
      }
    },
  },
  actions: {
    setDrawer(context, payload) {
      context.commit("setDrawer", payload);
    },
    setActiveCompanyId(context, company_id) {
      context.commit("setCompany", company_id);
    },
    setActiveCompanyTk(context, company_tk) {
      context.commit("setCompanyTk", company_tk);
    }
  }
};

export default App;
